import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Stats from './components/Stats';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Audiences from './components/Audiences';
import Clients from './components/Clients';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <Problem />
          <Stats />
          <Services />
          <Process />
          <Portfolio />
          <About />
          <Audiences />
          <Clients />
          <Team />
          <Contact />
        </main>
        <Footer />
        <ChatWidget />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
